module.exports = __webpack_public_path__ + "static/media/background.e1612fa2.jpg";